import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import ButtonStyles from '../../../styles/button';
import SpacingStyles from '../../../styles/helpers/spacing';

import SummaryStyles from './__styles__/Summary.styles';

export const CarrierInfo = ({ t, classes, carrier, notes, autoTendering }) => (
  <section className={classes.wrapper}>
    <h1 className={classnames(classes.headline7, classes.summaryTitle)}>
      {t('Carrier Information')}
    </h1>
    <div className={classes.summaryDetails}>
      <div>
        <div className={classes.summaryDetailsSection}>
          <p className={classes.subtitle2}>{t('Carrier')}</p>
          <p className={classes.body2Light}>{carrier.name}</p>
        </div>
      </div>
      {!autoTendering && (
        <div>
          <div className={classes.summaryDetailsSection}>
            <p className={classes.subtitle2}>{t('Phone Number')}</p>
            <p className={classes.body2Light}>
              {carrier.dispatchPhoneNumber || '--'}
            </p>
          </div>
        </div>
      )}
    </div>
    {notes && (
      <p className={classes.body2Light}>
        <strong>{`${t('Instructions')}: `}</strong>
        {notes}
      </p>
    )}
    {!notes && (
      <div className={classes.summaryDetailsSection}>
        <p className={classes.subtitle2}>{t('Instructions')}</p>
        <p className={classes.body2Light}>--</p>
      </div>
    )}
  </section>
);

const CarrierInfoWithTranslation = withNamespaces()(CarrierInfo);
export default withStyles(
  combineStyles(
    TypographyStyles,
    LayoutStyles,
    SpacingStyles,
    ButtonStyles,
    SummaryStyles
  )
)(CarrierInfoWithTranslation);
